import { render } from "./burgerIcon.vue?vue&type=template&id=7f34bb53"
import script from "./burgerIcon.vue?vue&type=script&lang=js"
export * from "./burgerIcon.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__